import { useLocation, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

// Superadmin «Tenantlara giriş» ilə mətbəx ekranına girəndə küncdə «Superadmin-ə qayıt» düyməsi.
// Admin və kassir ekranlarında (masalar daxil) bu düymə menyunun altındadır — orada göstərilmir.
export default function ImpersonationReturn() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, isImpersonating, exitImpersonation } = useAuthStore();
    if (!isImpersonating || !isImpersonating() || !user || user.role === 'superadmin') return null;
    const p = location.pathname;
    if (!p.startsWith('/kitchen')) return null;
    return (
        <button
            type="button"
            onClick={() => { exitImpersonation(); navigate('/superadmin/impersonate'); }}
            className="fixed bottom-3 left-3 z-[3000] rounded-full border border-purple-200 bg-white/95 px-4 py-2 text-xs font-bold text-purple-700 shadow-lg backdrop-blur hover:bg-purple-600 hover:text-white"
            title={`${user.tenant_name || ''} · ${user.name || ''}`}
        >
            ← Superadmin-ə qayıt
        </button>
    );
}
